module.exports = __webpack_public_path__ + "img/dpb-vault.d4283380.svg";